import { z } from 'zod'

export const SlotAvailability = {
  None: 0,
  AmAvailable: 1 << 0,
  PmAvailable: 1 << 1,
  BothAvailable: (1 << 0) | (1 << 1),
} as const
export type SlotAvailability = (typeof SlotAvailability)[keyof typeof SlotAvailability]

// export const TimeSlot = z.object({
//   slot: z.string(),
//   disabled: z.boolean(),
// })

// export const CourierDeliveryScheduleSchema = z.object({
//   date: z.string().date(),
//   timeSlots: z.array(TimeSlot),
// })

export const CourierDeliverySlotSchema = z.object({
  deliverySlotId: z.enum(['AM', 'PM']),
  label: z.string(),
  note: z.string().nullable(),
})
export type CourierDeliverySlot = z.infer<typeof CourierDeliverySlotSchema>

export const CourierDeliveryScheduleSchema = z.object({
  deliveryDate: z.string().date(),
  slotAvailability: z.nativeEnum(SlotAvailability),
  // IANA timezone the courier service resolved for the requested postcode (e.g. "Australia/Sydney").
  // `deliveryDate` is already a plain calendar-day string computed in this timezone, so callers
  // should never need to re-derive a timezone from the postcode themselves.
  timezone: z.string(),
  slots: z.array(CourierDeliverySlotSchema),
})

export type CourierDeliverySchedule = z.infer<typeof CourierDeliveryScheduleSchema>

export const ServiceabilitySchema = z.object({
  serviceable: z.boolean(),
  postcode: z.string(),
  suburb: z.string(),
})

export type Serviceability = z.infer<typeof ServiceabilitySchema>
